module.exports = __webpack_public_path__ + "images/ColdCreek_Small_SingleLine_Logo_KO_v5_cropped.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ColdCreek_Small_SingleLine_Logo_KO_v5_cropped.png
// module id = 31
// module chunks = 0